// Router del frontend.
//   /login                                — público
//   /elegir-tenant                        — L0 multi-tenant (F0-4)
//   /                                     — HomePage (redirect por rol)
//   /capturar                             — Selector línea pre-L2 (lider)
//   /capturar/:lineaId                    — L2 captura hora-línea (lider)
//   /supervisor                           — S1 dashboard
//   /supervisor/linea/:lineaId            — S2 detalle de línea
//   /supervisor/linea/:lineaId/capturar   — S5 captura por delegación
//   /supervisor/historico                 — S6 histórico y comparativas
//   /supervisor/mis-acciones              — S7 auditoría personal
//   /supervisor/pendientes                — S10 pendientes de validar (rango/turno/línea/OP)
//   /supervisor/datos-maquina             — S11 paros sin causal y horas de máquina por completar
//   /coordinador                          — C1 dashboard
//   /coordinador/programacion-lideres     — C2 programación semanal líderes
//   /coordinador/programacion-supervisores — C3 programación semanal supervisores
//   /coordinador/programacion-produccion  — C4 programación de producción (versiones + pedidos extra)
//   /coordinador/cumplimiento             — C5 análisis de cumplimiento (filtros + drill-down + export)
//   /coordinador/analisis-lineas          — Análisis de paros (tab "Por línea" por defecto)
//   /coordinador/analisis-paros           — Análisis de paros (tabs Por línea / Por causal)
//   /coordinador/analisis-personal        — C7 análisis de personal (líderes + supervisores)
//   /coordinador/informe                  — Informe Gerencial descargable (PDF, Fase A)
//   /coordinador/resumen-semanal          — C9 resumen semanal (KPIs comparativos + export CSV)
//   /coordinador/configuracion/skus       — C10 configuración SKUs y capacidades (matriz × línea)
//   /coordinador/configuracion/turnos     — C11 configuración turnos por planta
//   /coordinador/configuracion/metas-pits — metas del indicador Entrada a Pits
//   /coordinador/configuracion/usuarios   — C13 gestión usuarios (líderes + supervisores)
//   /coordinador/auditoria                — C14 auditoría (lectura, paginado)
//   /coordinador/configuracion/pantalla   — C15 configuración de la pantalla de planta (+ vista previa)
//   /coordinador/integracion              — integración de planta (conectividad + conflictos)
//   /coordinador/sobrellenado             — peso real vs nominal por hora (máquina)
//   /coordinador/cambios-referencia       — episodios de cambio de SKU vs estándar
//   /admin/integracion                    — A7 integración de planta (credenciales, mapeos, líneas)
//   /pantalla                             — P1 pantalla de planta (rol kiosco TV, fullscreen)
//
// Sonner Toaster + QueryProvider wrap el árbol entero.

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LoginPage } from '../features/auth/LoginPage';
import { SetPasswordPage } from '../features/auth/SetPasswordPage';
import { HomePage } from '../features/auth/HomePage';
import { ChooseTenantPage } from '../features/auth/ChooseTenantPage';
import { L2CapturaPage } from '../features/captura/L2CapturaPage';
import { L7HistorialPage } from '../features/captura/L7HistorialPage';
import { SelectorLineaPage } from '../features/captura/SelectorLineaPage';
import { CapturaTiendaPage } from '../features/captura/CapturaTiendaPage';
import { S1DashboardPage } from '../features/supervisor/S1DashboardPage';
import { S2DetalleLineaPage } from '../features/supervisor/S2DetalleLineaPage';
import { S5CapturaDelegacionPage } from '../features/supervisor/S5CapturaDelegacionPage';
import { S6HistoricoPage } from '../features/supervisor/S6HistoricoPage';
import { S7MisAccionesPage } from '../features/supervisor/S7MisAccionesPage';
import { S3BandejaIncidenciasPage } from '../features/supervisor/S3BandejaIncidenciasPage';
import { S8TiendasPage } from '../features/supervisor/S8TiendasPage';
import { S9ResumenHoraPage } from '../features/supervisor/S9ResumenHoraPage';
import { S10PendientesPage } from '../features/supervisor/S10PendientesPage';
import { S11DatosMaquinaPage } from '../features/supervisor/S11DatosMaquinaPage';
import { IntegracionPlantaPage } from '../features/coordinador/integracion/IntegracionPlantaPage';
import { SobrellenadoPage } from '../features/coordinador/integracion/SobrellenadoPage';
import { CambiosReferenciaPage } from '../features/coordinador/integracion/CambiosReferenciaPage';
import { A7IntegracionPlantaPage } from '../features/admin/integracion/A7IntegracionPlantaPage';
import { C1DashboardPage } from '../features/coordinador/C1DashboardPage';
import { C2ProgramacionLideresPage } from '../features/coordinador/C2ProgramacionLideresPage';
import { C3ProgramacionSupervisoresPage } from '../features/coordinador/C3ProgramacionSupervisoresPage';
import { C4ProgramacionProduccionPage } from '../features/coordinador/C4ProgramacionProduccionPage';
import { FacturacionProgramacionOpPage } from '../features/coordinador/FacturacionProgramacionOpPage';
import { FacturacionCrucePage } from '../features/coordinador/FacturacionCrucePage';
import { FacturacionNivelServicioPage } from '../features/coordinador/FacturacionNivelServicioPage';
import { FacturacionQPage } from '../features/coordinador/FacturacionQPage';
import { C5AnalisisCumplimientoPage } from '../features/coordinador/C5AnalisisCumplimientoPage';
import { ConfiguracionTiendasPage } from '../features/coordinador/ConfiguracionTiendasPage';
import { LineaTiempoPage } from '../features/coordinador/LineaTiempoPage';
import { AnalisisParosPage } from '../features/coordinador/AnalisisParosPage';
import { C7AnalisisPersonalPage } from '../features/coordinador/C7AnalisisPersonalPage';
import { PersonaPerfilPage } from '../features/coordinador/PersonaPerfilPage';
import { C9ResumenSemanalPage } from '../features/coordinador/C9ResumenSemanalPage';
import { C10ConfigSkusPage } from '../features/coordinador/C10ConfigSkusPage';
import { C11ConfigTurnosPage } from '../features/coordinador/C11ConfigTurnosPage';
import { MetasPitsPage } from '../features/coordinador/MetasPitsPage';
import { InformeGerencialPage } from '../features/coordinador/InformeGerencialPage';
import { C13UsuariosPage } from '../features/coordinador/C13UsuariosPage';
import { C14AuditoriaPage } from '../features/coordinador/C14AuditoriaPage';
import { C15ConfigPantallaPage } from '../features/coordinador/C15ConfigPantallaPage';
import { PantallaPage } from '../features/pantalla/PantallaPage';
import { DashboardPage } from '../features/directivo/DashboardPage';
import { LineasProduccionPage } from '../features/directivo/LineasProduccionPage';
import { LineaDetallePage } from '../features/directivo/LineaDetallePage';
import { FacturacionPage } from '../features/directivo/FacturacionPage';
import { PersonasPage } from '../features/directivo/PersonasPage';
import { D2ResumenSemanalPage } from '../features/directivo/D2ResumenSemanalPage';
import { D3AnalisisMensualPage } from '../features/directivo/D3AnalisisMensualPage';
import { D4AnalisisClientePage } from '../features/directivo/D4AnalisisClientePage';
import { D5AuditoriaPage } from '../features/directivo/D5AuditoriaPage';
import { A1ConfigTenantPage } from '../features/admin/A1ConfigTenantPage';
import { A2EstructuraPage } from '../features/admin/A2EstructuraPage';
import { A3CausalesPage } from '../features/admin/A3CausalesPage';
import { A4ClientesPage } from '../features/admin/A4ClientesPage';
import { A5UsuariosPage } from '../features/admin/A5UsuariosPage';
import { A6AuditoriaPage } from '../features/admin/A6AuditoriaPage';
import { MantenimientoDashboardPage } from '../features/mantenimiento/MantenimientoDashboardPage';
import { OrdenesTrabajoPage } from '../features/mantenimiento/OrdenesTrabajoPage';
import { OrdenTrabajoDetallePage } from '../features/mantenimiento/OrdenTrabajoDetallePage';
import { ActivosMttoPage } from '../features/mantenimiento/ActivosMttoPage';
import { RepuestosMttoPage } from '../features/mantenimiento/RepuestosMttoPage';
import { InformesMttoPage } from '../features/mantenimiento/InformesMttoPage';
import { PantallaAnalisisParosMtto } from '../features/mantenimiento/PantallaAnalisisParosMtto';
import { LineasParosMttoPage } from '../features/mantenimiento/LineasParosMttoPage';
import { ProgramacionTecnicosPage } from '../features/mantenimiento/ProgramacionTecnicosPage';
import { PersonalMttoPage } from '../features/mantenimiento/PersonalMttoPage';
import {
  RequireMantenimiento,
  RequireMttoAnalisis,
  RequireMttoGestionPersonal,
} from '../features/mantenimiento/MantenimientoShell';
import { SA1TenantsPage } from '../features/super-admin/SA1TenantsPage';
import { SA5SaludPage } from '../features/super-admin/SA5SaludPage';
import { SA7AuditoriaPage } from '../features/super-admin/SA7AuditoriaPage';
import { CopilotoFab } from '../features/copiloto/CopilotoFab';
import { ProtectedRoute, RequireTenantChosen } from '../lib/auth';
import { VerComoBanner } from '../features/directivo/ver-como/VerComoBanner';
import { QueryProvider } from './QueryProvider';

export function AppRoutes() {
  return (
    <QueryProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* Público: aterrizaje de invitación/recuperación. NO va detrás de
              ProtectedRoute/RequireTenantChosen — la sesión del link puede tener
              contexto de tenant incompleto y el guard la rebotaría. */}
          <Route path="/set-password" element={<SetPasswordPage />} />

          <Route
            path="/elegir-tenant"
            element={
              <ProtectedRoute>
                <ChooseTenantPage />
              </ProtectedRoute>
            }
          />

          {/* Líder */}
          <Route
            path="/capturar"
            element={
              <ProtectedRoute requiredRole="lider">
                <RequireTenantChosen>
                  <SelectorLineaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/capturar/:lineaId"
            element={
              <ProtectedRoute requiredRole="lider">
                <RequireTenantChosen>
                  <L2CapturaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/capturar-tienda/:lineaId"
            element={
              <ProtectedRoute requiredRole="lider">
                <RequireTenantChosen>
                  <CapturaTiendaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/historial"
            element={
              <ProtectedRoute requiredRole="lider">
                <RequireTenantChosen>
                  <L7HistorialPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />

          {/* Supervisor */}
          <Route
            path="/supervisor"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S1DashboardPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/linea/:lineaId"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S2DetalleLineaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/linea/:lineaId/capturar"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S5CapturaDelegacionPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/historico"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S6HistoricoPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/mis-acciones"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S7MisAccionesPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/tiendas"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S8TiendasPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/incidencias"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S3BandejaIncidenciasPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/resumen"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S9ResumenHoraPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/pendientes"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S10PendientesPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/supervisor/datos-maquina"
            element={
              <ProtectedRoute requiredRole={['supervisor', 'super_admin']}>
                <RequireTenantChosen>
                  <S11DatosMaquinaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />

          {/* Coordinador */}
          <Route
            path="/coordinador"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <C1DashboardPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/programacion-lideres"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <C2ProgramacionLideresPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/programacion-supervisores"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <C3ProgramacionSupervisoresPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/programacion-produccion"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <C4ProgramacionProduccionPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/facturacion/programacion-op"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <FacturacionProgramacionOpPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/facturacion/cruce"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <FacturacionCrucePage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/facturacion/nivel-servicio"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <FacturacionNivelServicioPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/facturacion/q"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <FacturacionQPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/cumplimiento"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <C5AnalisisCumplimientoPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/linea/:lineaId"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <LineaTiempoPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          {/* Ruta legacy: una sola URL por pantalla (política 4). El querystring
              (?tab, ?linea_id, período) viaja con el redirect. */}
          <Route
            path="/coordinador/analisis-lineas"
            element={
              <Navigate
                to={{ pathname: '/coordinador/analisis-paros', search: window.location.search }}
                replace
              />
            }
          />
          <Route
            path="/coordinador/analisis-paros"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <AnalisisParosPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/analisis-personal"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <C7AnalisisPersonalPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/personal/:userId"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <PersonaPerfilPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/resumen-semanal"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <C9ResumenSemanalPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/informe"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <InformeGerencialPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/configuracion/skus"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <C10ConfigSkusPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/configuracion/tiendas"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <ConfiguracionTiendasPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/configuracion/turnos"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <C11ConfigTurnosPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/configuracion/metas-pits"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <MetasPitsPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/configuracion/usuarios"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <C13UsuariosPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/auditoria"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'super_admin']}>
                <RequireTenantChosen>
                  <C14AuditoriaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/configuracion/pantalla"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <C15ConfigPantallaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/integracion"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <IntegracionPlantaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/sobrellenado"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <SobrellenadoPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordinador/cambios-referencia"
            element={
              <ProtectedRoute requiredRole={['coordinador', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <CambiosReferenciaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />

          {/* Pantalla de planta (P1) — rol kiosco TV. Coordinador/directivo/
              super_admin entran con su PROPIA sesión (vista previa C15). */}
          <Route
            path="/pantalla"
            element={
              <ProtectedRoute
                requiredRole={['pantalla', 'coordinador', 'directivo', 'super_admin']}
              >
                <RequireTenantChosen>
                  <PantallaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />

          {/* Directivo */}
          <Route
            path="/directivo"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <DashboardPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/directivo/lineas"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <LineasProduccionPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/directivo/lineas/:lineaId"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <LineaDetallePage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/directivo/personal"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <PersonasPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/directivo/facturacion"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <FacturacionPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/directivo/semanal"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <D2ResumenSemanalPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/directivo/mensual"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <D3AnalisisMensualPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/directivo/cliente"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <D4AnalisisClientePage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/directivo/auditoria"
            element={
              <ProtectedRoute requiredRole={['directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <D5AuditoriaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />

          {/* Admin Tenant */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole={['admin_tenant', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <A1ConfigTenantPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/clientes"
            element={
              <ProtectedRoute requiredRole={['admin_tenant', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <A4ClientesPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/estructura"
            element={
              <ProtectedRoute requiredRole={['admin_tenant', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <A2EstructuraPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/causales"
            element={
              <ProtectedRoute requiredRole={['admin_tenant', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <A3CausalesPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/integracion"
            element={
              <ProtectedRoute requiredRole={['admin_tenant', 'super_admin']}>
                <RequireTenantChosen>
                  <A7IntegracionPlantaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <ProtectedRoute requiredRole={['admin_tenant', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <A5UsuariosPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/auditoria"
            element={
              <ProtectedRoute requiredRole={['admin_tenant', 'directivo', 'super_admin']}>
                <RequireTenantChosen>
                  <A6AuditoriaPage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />

          {/* Mantenimiento (CMMS) — sin requiredRole: el gate es la capability
              puede_ver_mantenimiento (RequireMantenimiento redirige al home
              del rol si no la tiene; el gate duro sigue siendo el API). */}
          <Route
            path="/mantenimiento"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <MantenimientoDashboardPage />
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/paros"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <RequireMttoAnalisis>
                      <PantallaAnalisisParosMtto />
                    </RequireMttoAnalisis>
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/lineas"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <LineasParosMttoPage />
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/programacion"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <ProgramacionTecnicosPage />
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/personal"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <RequireMttoGestionPersonal>
                      <PersonalMttoPage />
                    </RequireMttoGestionPersonal>
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/ordenes"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <OrdenesTrabajoPage />
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/ordenes/:ordenId"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <OrdenTrabajoDetallePage />
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/activos"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <ActivosMttoPage />
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/repuestos"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <RepuestosMttoPage />
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mantenimiento/informes"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <RequireMantenimiento>
                    <RequireMttoAnalisis>
                      <InformesMttoPage />
                    </RequireMttoAnalisis>
                  </RequireMantenimiento>
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />

          {/* Super Admin (Jidoka, cross-tenant) */}
          <Route
            path="/super-admin"
            element={
              <ProtectedRoute requiredRole="super_admin">
                <SA1TenantsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/salud"
            element={
              <ProtectedRoute requiredRole="super_admin">
                <SA5SaludPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/auditoria"
            element={
              <ProtectedRoute requiredRole="super_admin">
                <SA7AuditoriaPage />
              </ProtectedRoute>
            }
          />

          {/* Home (redirect por rol). */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <RequireTenantChosen>
                  <HomePage />
                </RequireTenantChosen>
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <VerComoBanner />
      </BrowserRouter>
      <Toaster richColors position="top-center" />
      <CopilotoFab />
    </QueryProvider>
  );
}
